import { RouteConfig } from '@abaco/web-common/src/app';

export type BreadCrumb = { text: string; link?: string };

function breadCrumb(params: { [key: string]: string }, isSingleSubject = true): BreadCrumb[] {
    const ret: BreadCrumb[] = [];
    if (!isSingleSubject) {
        ret.push({
            text: "subject-list",
            link: "/"
        });
    }
    ret.push({
        text: "contracts-list",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts`
    });

    ret.push({
        text: "ppr",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/application/${encodeURIComponent(params.applicationId)}/ppr`
    });
    return ret;
}

const children: RouteConfig[] = [
    {
        name: "ppr-home",
        path: "/",
        component: () => import("./components/PPR/PPRHome.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // budget-components
    {
        name: "ppr-budget-components",
        path: "budget-components",
        component: () => import("./components/PPR/PPRBudgetComponents.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // budget-components-m6-p1
    {
        name: "ppr-budget-components-m6-p1",
        path: "budget-components-m6-p1",
        component: () => import("./components/PPR/PPRBudgetComponentsM6P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // budget-progress
    {
        name: "ppr-budget-progress",
        path: "budget-progress",
        component: () => import("./components/PPR/PPRBudgetProgress.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // final-remarks
    {
        name: "ppr-final-remarks",
        path: "final-remarks",
        component: () => import("./components/PPR/PPRFinalRemarks.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m1-p1
    {
        name: "ppr-measure-specific-targets-m1-p1",
        path: "measure-specific-targets-m1-p1",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM1P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m4-p1
    {
        name: "ppr-measure-specific-targets-m4-p1",
        path: "measure-specific-targets-m4-p1",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM4P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m4-p2
    {
        name: "ppr-measure-specific-targets-m4-p2",
        path: "measure-specific-targets-m4-p2",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM4P2.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m4-p3-roads
    {
        name: "ppr-measure-specific-targets-m4-p3-roads",
        path: "measure-specific-targets-m4-p3-roads",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM4P3Roads.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m4-p3-water
    {
        name: "ppr-measure-specific-targets-m4-p3-water",
        path: "measure-specific-targets-m4-p3-water",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM4P3Water.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m4-p4
    {
        name: "ppr-measure-specific-targets-m4-p4",
        path: "measure-specific-targets-m4-p4",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM4P4.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // measure-specific-targets-m6-p1
    {
        name: "ppr-measure-specific-targets-m6-p1",
        path: "measure-specific-targets-m6-p1",
        component: () => import("./components/PPR/PPRMeasureSpecificTargetsM6P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    // project-status-update
    {
        name: "ppr-project-status-update",
        path: "project-status-update",
        component: () => import("./components/PPR/PPRProjectStatusUpdate.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
];

const routes: RouteConfig[] = [
    {
        path: "/subject/:subjectId/contracts/:contractId/application/:applicationId/ppr",
        component: () => import("./components/PPR/PPR.vue"),
        props: true,
        meta: {
            breadCrumb
        },
        children
    },
];

export default routes;
